import request from '@/http'
// const urls = 'http://192.168.2.42:9999'
// let url = process.env.VUE_APP_APIMATERIALS
// let shebeiUrl = process.env.VUE_APP_SHEBEIAPI
export const apiFlexibleEmployment = {
  GetworkType: () => request.get(`/occupationConfig/list`), // 获取所需工种
  GetTypeAndStatus: () => request.get(`/employment/typeAndStatus`), // 获取用工类型和状态
  Getemployment: (params) => request.post('/employment/front', params), // 获取灵活用工列表
  GetDetail: (no) => request.get(`/employment/detail?no=${no}`), // 获取用工详情
  getLocation: () => request.get(`/sysArea/getAllArea`), // 获得地区信息
  sendCodeOldTel: (tel) => request.get(`/employment/apply/sendCode?telPhone=${tel}`), // 获得地区信息
  addForm: (params) => request.post('/employment/apply/add', params), // 提交报名
  GetSignUpList: (params) => request.get('/employment/apply/page', params), // 获取报名列表
  GetClassification: () => request.get(`/occupationConfig/listChild`), // 获取分类
  GetNewWorkType: (categoryNo) => request.get(`/occupationConfig/newList?categoryNo=${categoryNo}`), // 获取所需工种
  IsApply: (params) => request.get('/employment/apply/checkEmploymentApply', params), // 查是否可以报名
  getOrganization: () => request.get(process.env.VUE_APP_APIEQUIPMENT + `/getLeaseOrganization/getOrganization`),//获取客服人员列表
  laborEmploymentList: (params) => request.post('/laborEmployment/list', params), // 用户中心-劳务用工列表
  laborEmploymentSave: (params) => request.post('/laborEmployment', params), // 用户中心-保存劳务用工信息
  laborEmploymentDetail: (no) => request.get('/laborEmployment/detail/'+no), // 劳务用工详情-根据编号
  laborEmploymentDelete: (no) => request.delete('/laborEmployment/delete/'+no), // 根据编号删除劳务用工
  laborEmploymentStatus: (params) => request.delete(`/laborEmployment/changeStatus/${params.no}/${params.status}`), // 根据编号更改启用状态
  laborEmploymentIsApply: (no) => request.get(`/laborEmploymentApply/checkIsApply?no=${no}`), // 劳务用工详情-是否已经报名
  laborEmploymentApply: (params) => request.post('/laborEmploymentApply', params), // 劳务用工详情-保存劳务用工报名信息
}
